import React, { useCallback } from 'react';
import UDDateInput, { UDDateInputProps } from './component';
import { UDFormComponentProps } from '../types';
import { FieldProps, useFormikContext } from 'formik';
import UDFormFieldWrapper from '../../wrapper';

export type UDFormDateInputProps = UDFormComponentProps &
  Omit<UDDateInputProps, 'hasError' | 'valid' | 'onChange'>;

const UDFormDateInput = (props: UDFormDateInputProps) => {
  const { name, label, labelProps, containerProps, required, ...otherProps } =
    props;
  const { setFieldValue } = useFormikContext();
  const onChange = useCallback(
    (date: Date | null) => {
      setFieldValue(name, date ? date.toISOString() : date);
    },
    [name],
  );
  return (
    <UDFormFieldWrapper
      name={name}
      containerProps={containerProps}
      label={label}
      labelProps={labelProps}
      required={required}>
      {({ field, meta }: FieldProps<any>) => {
        return (
          <UDDateInput
            {...field}
            onChange={onChange}
            hasError={!!meta.error}
            valid={!meta.error && meta.touched && meta.value}
            {...otherProps}
          />
        );
      }}
    </UDFormFieldWrapper>
  );
};

export default UDFormDateInput;
